import { LineString } from 'ol/geom';
import GeometryCollection from 'ol/geom/GeometryCollection';
export default (({
  sizeFactor
}) => (feature, resolution) => {
  const geometry = feature.getGeometry();
  const properties = feature.getProperties();
  const coordinates = geometry.getCoordinates();
  const height = Math.log10(+properties.Value + 1);
  const direction = -properties.Direction * Math.PI / 180;
  const size = resolution * sizeFactor * height;

  if (!size) {
    return null;
  }

  const arrowGeometry = new GeometryCollection([new LineString([coordinates, [coordinates[0] - size * 3.5, coordinates[1]]]), new LineString([coordinates, [coordinates[0] - size, coordinates[1] + size]]), new LineString([coordinates, [coordinates[0] - size, coordinates[1] - size]])]);
  arrowGeometry.rotate(direction - Math.PI / 2, coordinates);
  return arrowGeometry;
});